import Tooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/Info'
import { ReactNode } from 'react'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Text } from 'shared/components/Text/Text'
import { useTeamV3 } from 'shared/hooks/query/useTeamV3'
import { DriverStatus } from 'shared/models/user'
import { darkGray } from 'shared/theme/colors'

import { consoleTooltipStyles } from '../Common/Tooltip'

interface TeamMembersProps {
  className?: string
  teamId: string
  titleRender?: (total: number) => ReactNode
}

export function TeamMembers({ className, teamId, titleRender }: TeamMembersProps) {
  const tooltipClasses = consoleTooltipStyles()
  const { team } = useTeamV3(teamId, { enabled: true })

  const teamMembers = (team?.members ?? []).filter(
    (user) => user.driver.status !== DriverStatus.DEACTIVATED && user.driver.status !== DriverStatus.INACTIVE
  )
  const drivers = teamMembers.filter((user) => user.isTeamDriver && !user.isTeamAdmin)
  const adminDrivers = teamMembers.filter((user) => user.isTeamAdmin && user.isTeamDriver)
  const admins = teamMembers.filter((user) => user.isTeamAdmin && !user.isTeamDriver)
  const title: ReactNode = titleRender?.(teamMembers.length) ?? `${teamMembers.length} total`

  return (
    <FlexBox gap="8px" alignItems="center" className={className}>
      <Text variant="header3" fontColor={darkGray}>
        {title}
      </Text>
      <Tooltip
        title={
          <FlexBox isColumn gap="8px">
            <Text variant="paragraph2" fontColor={darkGray}>
              Drivers - {drivers.length}
            </Text>
            <Text variant="paragraph2" fontColor={darkGray}>
              Admin drivers - {adminDrivers.length}
            </Text>
            <Text variant="paragraph2" fontColor={darkGray}>
              Admins - {admins.length}
            </Text>
          </FlexBox>
        }
        placement="right"
        classes={{ tooltip: tooltipClasses.tooltip }}
      >
        <InfoIcon className={tooltipClasses.infoIcon} color="primary" fontSize="small" />
      </Tooltip>
    </FlexBox>
  )
}
